module.exports = __webpack_public_path__ + "img/Misaligned Engraving.badf5cca.png";